import { Component } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'app-device-settings-speech-recognition',
  templateUrl: './device-settings-speech-recognition.component.html',
  styleUrls: ['./device-settings-speech-recognition.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'settings',
    },
  ],
})
export class DeviceSettingsSpeechRecognitionComponent {
  refreshPage(): void {
    window.location.reload();
  }
}
